import { StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import type { FeaturePageActionViewModel } from '../../types/featurePage';
import { AppButton } from '../ui/AppButton';

type FeaturePageActionListProps = {
  actions: FeaturePageActionViewModel[];
  onPressAction: (href: string | null) => void;
};

export function FeaturePageActionList({
  actions,
  onPressAction,
}: FeaturePageActionListProps) {
  if (actions.length === 0) {
    return null;
  }

  return (
    <View style={styles.actions}>
      {actions.map((action) => (
        <AppButton
          key={action.id}
          label={action.label}
          variant={action.kind === 'primary' ? 'primary' : 'secondary'}
          onPress={() => onPressAction(action.href)}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  actions: {
    gap: tokens.spacing.md,
  },
});
